export const validators = {
  required: (v) => (v && String(v).trim() ? "" : "This field is required"),
  email: (v) => {
    if (!v || !v.trim()) return "Email is required";
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? "" : "Enter a valid email address";
  },
  indianPhone: (v) => {
    if (!v || !v.trim()) return "Phone number is required";
    const clean = v.replace(/[\s-]/g, "");
    return /^(\+91)?[6-9]\d{9}$/.test(clean) ? "" : "Enter a valid 10-digit Indian mobile number";
  },
  pincode: (v) => {
    if (!v || !v.trim()) return "PIN code is required";
    return /^[1-9]\d{5}$/.test(v.trim()) ? "" : "Enter a valid 6-digit PIN code";
  },
  minLength: (n, label = "This field") => (v) =>
    (v || "").trim().length >= n ? "" : `${label} must be at least ${n} characters`,
};

export const runValidators = (fields) => {
  const errors = {};
  let hasError = false;
  for (const [key, [value, fns]] of Object.entries(fields)) {
    for (const fn of fns) {
      const msg = fn(value);
      if (msg) {
        errors[key] = msg;
        hasError = true;
        break;
      }
    }
  }
  return { errors, hasError };
};
